import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpInterceptor } from "@angular/common/http";
import { HttpRequest } from "@angular/common/http";
import { HttpHandler } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { HttpSentEvent } from "@angular/common/http";
import { HttpHeaderResponse } from "@angular/common/http";
import { HttpProgressEvent } from "@angular/common/http";
import { HttpResponse } from "@angular/common/http";
import { HttpUserEvent } from "@angular/common/http";
import { catchError } from 'rxjs/operators';
import { MessageService } from '../_services/message.service.';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from "src/environments/environment";
import { TokenService } from "../_services/token.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    constructor(
        private messageService: MessageService,
        private tokenService: TokenService,
        private router: Router,
        private activatedRoute: ActivatedRoute) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent
        | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

            if (req.url.includes('ipify'))
            return next.handle(req);

            // A sessão do portal do motorista é independente da sessão administrativa.
            // O interceptor específico já adicionou Authorization e language.
            if (req.headers.has('X-Driver-Portal')) {
                return next.handle(req);
            }

            if (req.headers.has('Authorization') && req.headers.has('language')) {
                return next.handle(req);
            }

            // req = req.clone({
            //     setHeaders: {
            //         'x-codigo-loja': environment.codLoja
            //     }
            // });

            if (!req.url.endsWith('/Token') && !req.url.includes('getnet') && !req.url.endsWith('/UtilizarVoucher') && !req.url.endsWith('/ValidarVoucher')) {
                if (this.tokenService.hasToken()) {
                    let token = this.tokenService.getToken();
                    req = req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${token}`
                        }
                    });
    
                    let tokenExpirationDate = this.tokenService.getTokenExpirationDate(token);
                    if(tokenExpirationDate == null){
                        this.tokenService.logout();
                        this.router.navigate([window.location.pathname]);
                    }

                    let date = new Date();
    
                    if (!req.url.includes("Token")) {
                        if (tokenExpirationDate != null && date >= tokenExpirationDate) {
                            this.tokenService.refreshToken().subscribe(
                                res => {},
                                err => { 
                                    if (err.status == 401) {
                                        this.tokenService.logout();
                                        this.router.navigate([window.location.pathname]);
                                    }
                                }
                            );
                        }
                    }
                }
                else{
                    return next.handle(req).pipe(
                        catchError((error: HttpErrorResponse) => {
                            if (error.status == 401) {
                                this.tokenService.logout();
                                // this.messageService.show("A sua sessão expirou. Realize novamente o login para acessar o sistema.");
                                this.router.navigate(['/login']);
                            }
            
                            return throwError(error);
                        })
                    );
                }
    
            }
    
            if (req.url.includes("Token")) {
                return next.handle(req);
            }
            
            return next.handle(req).pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status == 401) {
                        this.tokenService.logout();
                        this.messageService.show("A sua sessão expirou. Realize novamente o login para acessar o sistema.");
                        this.router.navigate(['login']);
                    }
    
                    return throwError(error);
                })
            );
        }
    }
